import styles from "./analytics-cards.module.css"

export default function SystemStatus({ status }) {
  return (
    <div className={styles.card}>
      <h3>System Status</h3>
      <div className={styles.statusGrid}>
        <StatusItem label="Profit" status={status?.profit} />
        <StatusItem label="Orders" status={status?.orders} />
        <StatusItem label="Alerts" status={status?.alerts} />
      </div>
    </div>
  )
}

function StatusItem({ label, status }) {
  return (
    <div className={styles.statusItem}>
      <span className={styles.statusIndicator}>{status}</span>
      <span className={styles.statusLabel}>{label}</span>
    </div>
  )
}
